import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=085dcda2&scoped=true"
import script from "./UserInformation.vue?vue&type=script&lang=js"
export * from "./UserInformation.vue?vue&type=script&lang=js"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=085dcda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085dcda2",
  null
  
)

export default component.exports